import {
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { GridComponent } from "app/modules/shared/components/grid/grid.component";
import {
  ExplorerService,
  TabConfig,
} from "app/modules/shared/services/explorer.service";
import { KlLoadingService } from "app/modules/shared/services/kl-loading.service";
import { DynamicComponent } from "app/data/dashboard/interfaces/dynamic-component.interface";
import { ApiService } from "app/modules/shared/services/base/api.service";
import { MaterialDto } from "@dashboard/modules/material-management/material/model/material.dto";
import { MaterialFormComponent } from "@dashboard/modules/material-management/material/components/material-form/material-form.component";
import { UtilService } from "@app/modules/shared/services/util.service";

@Component({
  selector: "kl-material-list",
  templateUrl: "./material-list.component.html",
  styleUrls: ["./material-list.component.scss"],
})
export class MaterialListComponent implements OnInit, AfterViewInit {
  @Input() mode;
  @Input() tabId: string;
  @Input() modalId: string;
  @Input() templateContext: any;
  @Input() dblSelect = false;
  filterObject: any;
  input: MaterialDto = new MaterialDto();
  loading: boolean;
  data: Object;
  material: {
    id: number;
  };
  @ViewChild(forwardRef(() => GridComponent), { static: true })
  gridComponent: any;
  dropdownActions = [
    {
      icon: "fal fa-copy",
      slug: "copy",
      method: (cell) => {
        if (this.utilService.isShow(this.tabId + ".006")) {
          this.gridComponent.alertShow = false;
          this.klLoadingService.show("loading");
          this.apiService.getDataById("material", cell.item.id).subscribe(
            (response) => {
              if (response === undefined) {
                this.handleError("error_data");
              } else {
                const copyData = UtilService.deepCopy(response);
                const tabConfig = <TabConfig>{
                  id: "materialCopy" + response.id,
                  title: "material",
                  childTemplate: <DynamicComponent>{
                    mode: "copy",
                    tabId: "materialCopy" + response.id,
                    template: MaterialFormComponent,
                    dataContext: copyData,
                    service: "material",
                    isReadOnly: false,
                  },
                  isCloseable: true,
                };
                this.explorerService.openTab(tabConfig);
              }
            },
            (error) => this.handleError(error)
          );
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
      },
    },
  ];

  filterSelectItems = [
    {
      name: "code",
      description: "code",
    },
    {
      name: "description",
      description: "description",
    },
    {
      name: "short_description",
      description: "short_description",
    },
    {
      name: "material_barcodes",
      description: "material_barcode",
      objectKey: "barcode",
      type: "array",
      parameterName: "barcode",
    },
  ];

  constructor(
    private apiService: ApiService,
    private explorerService: ExplorerService,
    private utilService: UtilService,
    private klLoadingService: KlLoadingService
  ) {}

  ngOnInit() {
    if (this.templateContext) {
      this.gridComponent.templateContext = this.templateContext;
    }
    this.filterObject = {};
  }

  ngAfterViewInit(): void {
    if (this.dropdownActions.length > 0) {
      this.gridComponent.actions = this.dropdownActions;
    }
    if (this.mode) {
      this.gridComponent.mode = this.mode;
    }
  }

  handleError(error) {
    this.klLoadingService.hide();
    this.gridComponent.alertMessage = this.utilService.alertErrorMessage(error);
    this.gridComponent.alertType = "error";
    this.gridComponent.alertShow = true;
    this.gridComponent.cd.markForCheck();
  }
}
